import React from 'react';
import { connect } from 'react-redux';
import StaticLoader from './StaticLoader';
import type { State } from '../../types';

type Props = {
  display: boolean,
}

const Loader = (props: Props): React.ReactElement => {
  const { display } = props;

  return (
    <StaticLoader display={display} />
  );
};

const mapStateToProps = (state: State) => ({
  display: state.displayLoader,
});

const ConnectedLoader = connect(mapStateToProps)(Loader);

export default ConnectedLoader;
